import { makeStyles } from "@material-ui/core/styles";

// Estilo compartilhado do backoffice. Mesma linguagem visual do resto do app
// (tokens de theme.app), mas com densidade maior: aqui a tela é de leitura de
// números, não de configuração.
export const useAdminStyles = makeStyles(theme => ({
  page: { padding: 24, background: theme.app.canvas || theme.app.bg, minHeight: "100%" },
  wrap: { maxWidth: 1180, margin: "0 auto" },
  head: { display: "flex", alignItems: "center", gap: 12, marginBottom: 16 },
  h1: { fontFamily: theme.app.heading, fontSize: 22, fontWeight: 700, color: theme.app.ink },
  grow: { flex: 1, minWidth: 0 },
  tabs: { display: "flex", gap: 4, marginBottom: 18, borderBottom: `1px solid ${theme.app.border}` },
  tab: {
    fontSize: 13.5, fontWeight: 600, color: theme.app.textSecondary, padding: "8px 12px",
    cursor: "pointer", borderBottom: "2px solid transparent", marginBottom: -1,
    "&:hover": { color: theme.app.ink },
  },
  tabOn: { color: theme.app.ink, borderBottomColor: theme.app.dark },

  cards: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 12, marginBottom: 18 },
  kpi: { background: "#fff", border: `1px solid ${theme.app.border}`, borderRadius: 14, padding: "14px 16px" },
  kpiLabel: { fontSize: 11.5, color: theme.app.textSecondary, textTransform: "uppercase", letterSpacing: ".04em", fontWeight: 700 },
  kpiValue: { fontFamily: theme.app.heading, fontSize: 26, fontWeight: 700, color: theme.app.ink, lineHeight: 1.2, marginTop: 4 },
  kpiHint: { fontSize: 12, color: theme.app.textTertiary, marginTop: 2 },

  card: { background: "#fff", border: `1px solid ${theme.app.border}`, borderRadius: 14, padding: 18, marginBottom: 16 },
  cardTitle: { fontSize: 14, fontWeight: 600, color: theme.app.ink, marginBottom: 4 },
  cardSub: { fontSize: 12, color: theme.app.textTertiary, marginBottom: 12 },
  cols: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, alignItems: "start" },

  row: { display: "flex", alignItems: "center", gap: 12, padding: "8px 0", borderTop: `1px solid ${theme.app.lineSoft}` },
  rowFirst: { borderTop: "none" },
  strong: { fontSize: 13.5, fontWeight: 600, color: theme.app.ink },
  muted: { fontSize: 12.5, color: theme.app.textSecondary },
  num: { fontSize: 13.5, fontWeight: 700, color: theme.app.ink, fontVariantNumeric: "tabular-nums" },
  empty: { fontSize: 13, color: theme.app.textTertiary, padding: "10px 0" },

  // barra proporcional — comparar números soltos numa lista é difícil
  bar: { height: 6, borderRadius: 4, background: theme.app.lineSoft, overflow: "hidden", marginTop: 5 },
  barFill: { height: "100%", background: theme.app.dark, borderRadius: 4 },

  tableWrap: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: {
    textAlign: "left", fontSize: 11.5, fontWeight: 700, color: theme.app.textSecondary,
    textTransform: "uppercase", letterSpacing: ".04em", padding: "8px 10px",
    borderBottom: `1px solid ${theme.app.border}`, whiteSpace: "nowrap", cursor: "pointer", userSelect: "none",
  },
  thPlain: { cursor: "default" },
  td: { padding: "9px 10px", borderBottom: `1px solid ${theme.app.lineSoft}`, whiteSpace: "nowrap", color: theme.app.ink },
  tdNum: { textAlign: "right", fontVariantNumeric: "tabular-nums" },
  trLink: { cursor: "pointer", "&:hover td": { background: theme.app.hover } },

  pill: { fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 6, textTransform: "uppercase", letterSpacing: ".03em", display: "inline-block" },
  ok: { color: "#1E7E34", background: "#E8F5EC" },
  warn: { color: "#9A6410", background: "#FBF1DE" },
  bad: { color: "#B12A2A", background: "#FBE9E9" },
  neutral: { color: theme.app.textSecondary, background: theme.app.lineSoft },

  filters: { display: "flex", gap: 8, alignItems: "center", marginBottom: 12, flexWrap: "wrap" },
  chip: {
    fontSize: 12.5, fontWeight: 600, color: theme.app.textSecondary, padding: "5px 11px",
    borderRadius: 999, border: `1px solid ${theme.app.border}`, cursor: "pointer", background: "#fff",
    "&:hover": { background: theme.app.hover },
  },
  chipOn: { color: "#fff", background: theme.app.dark, borderColor: theme.app.dark, "&:hover": { background: theme.app.dark } },
}));

export const brl = c => `R$ ${((c || 0) / 100).toFixed(2).replace(".", ",")}`;
export const num = v => Number(v || 0).toLocaleString("pt-BR");
export const date = d => (d ? new Date(d).toLocaleDateString("pt-BR") : "—");
export const dateTime = d =>
  d ? new Date(d).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

// "há 3 dias" diz mais que a data quando a pergunta é "está usando?"
export const since = d => {
  if (!d) return "nunca";
  const ms = Date.now() - new Date(d).getTime();
  const h = Math.floor(ms / 3600000);
  if (h < 1) return "agora há pouco";
  if (h < 24) return `há ${h}h`;
  const dias = Math.floor(h / 24);
  if (dias < 30) return `há ${dias}d`;
  return `há ${Math.floor(dias / 30)} mês(es)`;
};

export default useAdminStyles;
